import List from "@material-ui/core/List";
import Drawer from "@material-ui/core/Drawer";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { css, cx } from "emotion";
import React from "react";
import "./BaseLayout.scss";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import AppStore from "../../Store/AppStore";
import DesktopMacIcon from "@material-ui/icons/DesktopMac";
import History from "../../History/History";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
// import {use} from 'react-router-dom'
import logoSHOPFROMIZY from "../../assets/images/logo-SHOPFROMIZY.png";
import IconProfileGeneral from "../../assets/icons/ic_profile_general.svg";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Collapse from "reactstrap/lib/Collapse";
import { checkModuleAccess } from "../../Helpers/role";
import { useEffect } from "react";
import { useState } from "react";

const user = JSON.parse(localStorage.getItem("user"));
// console.log(user);
const lastVisit = JSON.parse(localStorage.getItem("lastVisit"));

function getNavData(pathname) {
  const modules = user?.role?.modules;
  if (modules.length > 0) {
    for (let index = 0; index < modules.length; index++) {
      const module = modules[index];
      if (module.show_st === true && module.features.length > 0) {
        for (let indexF = 0; indexF < module.features.length; indexF++) {
          const feature = module.features[indexF];
          if (feature.path === pathname) {
            return {
              mod: module.id,
              feat: feature.id,
              path: pathname,
            };
          }
        }
      }
    }
  }
}

const Navigation = () => {
  const location = useLocation();
  const history = useHistory();
  const [appState, appAction] = AppStore();
  const modules1 = user?.role?.modules;
  const [modules, setmodules] = useState([]);

  // sort menu
  const getSort = () => {
    // setmodules(modules1);
    let newmod = modules1.sort(function (a, b) {
      if (a.name === "Property") {
        return -1;
      } else if (a.name === "Finance") {
        return b.name === "Property" ? 1 : -1;
      } else if (a.name === "Voucher") {
        return b.name === "Property" || b.name === "Finance" ? 1 : -1;
      } else {
        return 1;
      }
    });
    setmodules(newmod);
    // console.log(newmod);
  };
  useEffect(() => {
    getSort();
  }, []);
  // console.log(modules);

  const [navData, setNavData] = React.useState(
    appState.navData !== "" ? appState.navData : lastVisit
  );

  const [locPathname, setLocPathname] = React.useState(location.pathname);

  const handleClickModule = (id, path) => {
    const data = {
      mod: id === navData?.mod ? "" : id,
      feat: 0,
      path: path,
    };

    setNavData(data);
    localStorage.setItem("lastVisit", JSON.stringify(data));
    setLocPathname(path);
  };

  const handleClickFeature = (modId, id, path) => {
    if (modId !== navData?.mod || id !== navData?.feat) {
      const data = {
        mod: modId,
        feat: id,
        path: path,
      };
      setNavData(data);
      localStorage.setItem("lastVisit", JSON.stringify(data));
      setLocPathname(path);
    }
  };

  React.useEffect(() => {
    if (history.location.state && history.location.state.updateNav) {
      const data = getNavData(history.location.pathname);
      handleClickFeature(data.mod, data.feat, data.path);
      appAction.setNavData(data);
    }
  }, [history]);

  React.useEffect(() => {
    if (locPathname !== "" && locPathname !== location.pathname) {
      appAction.setNavData(navData);
      History.push(navData?.path);
    }
  }, [location.pathname, locPathname, appAction, navData, appState]);

  return (
    <ul className="nav sidebar-nav nav-list">
      <li
        key={0}
        className={navData?.mod === 0 || !navData ? "active font-bold" : ""}
      >
        <button
          type="button"
          className="btn btn-block bg-white border-0 rounded-0 accordion-heading"
          onClick={() => handleClickModule(0, "/home")}
        >
          <span className="nav-header-primary">
            <span className="nav-icon" style={{ width: 24, height: 24 }}>
              <DesktopMacIcon />
            </span>
            <span className="nav-text">Guide</span>
          </span>
        </button>
      </li>
      {modules?.map((module, key) => {
        return (
          <React.Fragment key={key}>
            {module?.show_st && (
              <li
                key={module?.id}
                className={
                  navData?.mod === module?.id ? "active font-bold" : ""
                }
              >
                <button
                  type="button"
                  className="btn btn-block bg-white border-0 rounded-0 accordion-heading"
                  onClick={() => handleClickModule(module?.id, "")}
                >
                  <span className="nav-header-primary">
                    <span
                      className={cx(
                        css`
                          background: url(${module?.icon_url});
                        `,
                        "nav-icon"
                      )}
                    ></span>
                    <span className="nav-text">{module?.name}</span>
                    {module?.features?.length > 0 &&
                      module?.id !== navData?.mod && (
                        <ArrowRightIcon className="ml-auto" />
                      )}
                    {module?.features?.length > 0 &&
                      module?.id === navData?.mod && (
                        <ArrowDropDownIcon className="ml-auto" />
                      )}
                  </span>
                </button>
                {module?.features?.length > 0 && (
                  <ul
                    className={
                      navData?.mod === module?.id
                        ? "nav nav-list sub-nav-list collapse show"
                        : "nav nav-list sub-nav-list collapse"
                    }
                  >
                    {module?.features?.map((feature) => {
                      return (
                        <li
                          key={`${module.id}-${feature.id}`}
                          className={
                            navData?.mod === module.id &&
                            navData?.feat === feature.id
                              ? "active font-bold"
                              : "font-normal"
                          }
                        >
                          <button
                            type="button"
                            className="btn btn-block btn-white border-0 rounded-0"
                            onClick={() =>
                              handleClickFeature(
                                module.id,
                                feature.id,
                                feature.path
                              )
                            }
                          >
                            <span className="nav-text">{feature?.name}</span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            )}
          </React.Fragment>
        );
      })}
    </ul>
  );
};

const SidebarDrawer = (props) => {
  const {
    drawerWidth,
    isMobile,
    variant,
    show,
    onCloseAction,
    onClickPengaturan,
    onClickKeluar,
  } = props;
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const useStyles = makeStyles((theme) => ({
    drawerPaper: {
      width: drawerWidth,
    },
  }));
  const classes = useStyles();

  const handleDrawerToggle = (openSt) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    onCloseAction(openSt);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <Drawer
      variant={variant}
      anchor="left"
      open={show}
      onClose={handleDrawerToggle(false)}
      classes={{
        paper: classes.drawerPaper,
      }}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <div
        className={cx(
          !isMobile
            ? css`
                width: 260px;
                height: calc(100vh - 70px) !important;
                max-height: calc(100vh - 70px) !important;
                margin-top: 70px;
              `
            : css`
                width: 260px;
                height: calc(100vh - 70px) !important;
                max-height: calc(100vh - 70px) !important;
                margin-top: 0px;
              `
        )}
      >
        {isMobile && (
          <div className="d-flex flex-column justify-content-start align-items-start">
            <div
              className={css`
                text-align: center;
                height: 56px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
              `}
            >
              <img src={logoSHOPFROMIZY} alt="logo" style={{ height: 40 }} />
            </div>
            <button
              className={cx(
                css`
                  box-shadow: none !important;
                  outline: none !important;
                  border: none !important;
                  :focus {
                    box-shadow: none !important;
                    outline: none !important;
                    border: none !important;
                  }
                  :active {
                    box-shadow: none !important;
                    outline: none !important;
                    border: none !important;
                  }
                `,
                "w-100 p-3 d-flex justify-content-start align-items-center border-0 rounded-0 bg-white"
              )}
              onClick={toggleDropdown}
            >
              <img
                src={
                  user?.type === "tenant"
                    ? user?.tenant?.logo?.square
                    : IconProfileGeneral
                }
                alt={user?.name}
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 6,
                  marginRight: 12,
                }}
              />
              <div className="d-inline-block line-height-1 text-left">
                <span className="font-12 font-bold d-block">
                  {user?.name || "Admin"}
                </span>
                <span className="font-9">{user?.role?.name || "-"}</span>
              </div>
              {dropdownOpen && <ArrowDropUpIcon className="ml-auto" />}
              {!dropdownOpen && <ArrowDropDownIcon className="ml-auto" />}
            </button>
            <Collapse
              isOpen={dropdownOpen}
              className={cx(
                css`
                  background-color: #eeeeee;
                `,
                "p-3 w-100"
              )}
            >
              {checkModuleAccess(9) && (
                <div
                  className="text-left py-2 px-0 font-10"
                  onClick={onClickPengaturan}
                >
                  <SettingsIcon
                    className="mr-2 font-14"
                    style={{ color: "#757575" }}
                  />
                  Pengaturan
                </div>
              )}
              <div
                className="text-left py-2 px-0 font-10"
                onClick={onClickKeluar}
              >
                <ExitToAppIcon
                  className="mr-2 font-14"
                  style={{ color: "#757575" }}
                />
                Keluar
              </div>
            </Collapse>
          </div>
        )}
        <Navigation drawerWidth={drawerWidth} />
      </div>
    </Drawer>
  );
};

export default SidebarDrawer;
